<template>
  <template v-if="showWarning">
    <div class="footer-space"><!-- spacer --></div>
    <div class="warning-box sticky-footer">
      <span class="version-string">{{ version }}</span>
      <span class="environment">{{ warning }}</span>
      <!-- Dummy for proper centering -->
      <span class="version-string">{{ version }}</span>
    </div>
  </template>

  <div v-else class="static-footer">
    <span class="version-string">{{ version }}</span>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    showWarning: boolean;
    version: string;
    warning: string | undefined;
  }>();
</script>

<style scoped lang="scss">
  .version-string {
    color: #999999;
    font-size: 0.6rem;
  }

  $margin-horizontal: 0.5em;
  .sticky-footer {
    position: fixed;
    bottom: 0;
    margin: 1em $margin-horizontal 0.5em $margin-horizontal;
    width: calc(100% - 2 * $margin-horizontal);

    display: flex;
    justify-content: space-between;
    column-gap: 1em;
    align-items: center;

    &.warning-box span {
      &.environment {
        flex-grow: 1;
      }

      &:not(.environment) {
        flex-shrink: 0;
      }

      &:last-of-type:not(:only-of-type) {
        visibility: hidden;
      }

      @media only screen and (max-width: 600px) {
        &:last-of-type:not(:only-of-type) {
          display: none;
        }
      }
    }
  }

  .footer-space {
    min-height: 2.5em;

    @media only screen and (max-width: 420px) {
      min-height: 3.3rem;
    }
  }

  .warning-box {
    border: solid 2px rgba(#ffa500, 0.4);
    background-color: rgba(#f5deb3, 0.9);
    padding: 0.3em 1em;

    .environment {
      color: #222;
      text-align: center;
    }
  }

  .static-footer {
    padding: 0 1.5em 0 1.5em;
    margin-bottom: 0.5em;
  }
</style>
